module.exports = __webpack_public_path__ + "static/img/credit-card.86fe233.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/credit-card.jpg
// module id = 5Blw
// module chunks = 1